export const siteData = {
  name: '每日大赛mrds',
  slogan: '每天都有新舞台，人人都是创作者',
  heroTag: '#全民创作竞技',
  heroIntro:
    '每日大赛mrds是一个面向全民的创作竞技平台，每天发布新鲜话题和赛道，任何人都可以通过大赛发布页面提交自己的原创作品、发送爆料素材参与角逐。无论是摄影、短视频、文字创作还是生活记录，只要你有想法，就能上榜提名。我们相信好内容值得被看见，通过每日更新的话题机制和透明榜单，让每一位创作者都有机会成为焦点。',
  heroStats: [
    { label: '今日参赛人数', value: '28,463' },
    { label: '累计上榜作品', value: '156,892' },
    { label: '覆盖话题赛道', value: '240+' },
  ],
  primaryCTA: { text: '立即参赛', href: '#faq' },
  secondaryCTA: { text: '发送爆料', href: '#contact' },
};

export const faqItems = [
  {
    q: '每日大赛怎么参与？',
    a: '很简单！每天我们会在平台发布当日话题，你只需围绕话题创作内容，通过大赛发布页面提交作品即可。支持图片、视频和文字多种形式，提交后自动进入当日榜单候选池。',
  },
  {
    q: 'mrds参赛入口在哪里？',
    a: '参赛入口就在首页 Hero 区域下方的"立即参赛"按钮，点击即可跳转到参赛指南区域。你也可以直接在 #contact 区域找到投稿入口，选择对应的话题赛道提交你的作品。',
  },
  {
    q: '如何发送爆料上榜提名？',
    a: '如果你发现了有趣的内容或想推荐优秀作品，可以进入"投稿爆料"区域，填写爆料信息和素材链接。审核通过后，被提名的内容将直接进入榜单候选，获得额外曝光机会。',
  },
  {
    q: '榜单排名是怎么计算的？',
    a: '榜单排名综合计算三个维度：作品质量分（40%）、社区互动量（35%）和时效热度（25%）。每小时更新一次排名，确保榜单始终反映最新的内容趋势和用户反馈。',
  },
  {
    q: '参与大赛有什么奖励？',
    a: '每日榜单前3名创作者将获得首页专属展示位、官方社交账号转发推荐，以及"今日之星"认证徽章。月度累计上榜次数最多的创作者还将获得年度创作人邀请资格和实物奖品。',
  },
];

export const carouselItems = [
  {
    title: '今日话题：夏日记忆',
    tag: '热门赛道',
    desc: '拍下你眼中最美的夏日瞬间，无论是海滩落日、城市光影还是街角一隅，用镜头记录这个夏天的独特记忆。',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20summer%20scene%20with%20golden%20sunset%20light%20through%20leaves%2C%20warm%20tones%2C%20artistic%20photography%20style%2C%20soft%20bokeh%20background%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20editorial%20quality%2C%20minimalist%20aesthetic&width=800&height=500&seq=carousel-01&orientation=landscape',
    stat: '1.2w 人参与',
  },
  {
    title: '创意摄影挑战赛',
    tag: '月度大赛',
    desc: '不限题材，不限器材，用最具创意的视角重新定义日常。倒影、微距、航拍，刷新你的创作边界。',
    image: 'https://readdy.ai/api/search-image?query=Creative%20photography%20with%20unique%20perspective%2C%20reflection%20on%20wet%20city%20street%2C%20vibrant%20neon%20lights%2C%20artistic%20composition%2C%20modern%20urban%20aesthetic%2C%20clean%20minimal%20background%2C%20editorial%20style%2C%20soft%20contrast&width=800&height=500&seq=carousel-02&orientation=landscape',
    stat: '8.6k 人参与',
  },
  {
    title: '美食日记大赏',
    tag: '新赛道',
    desc: '从家常菜到探店打卡，用镜头讲述你和美食的故事。摆盘、制作过程、餐厅氛围，角度不限。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20food%20photography%20flat%20lay%20with%20fresh%20ingredients%2C%20warm%20natural%20lighting%2C%20artistic%20composition%2C%20wooden%20table%20surface%2C%20herbs%20and%20vegetables%2C%20minimal%20clean%20aesthetic%2C%20editorial%20food%20styling%2C%20soft%20shadows&width=800&height=500&seq=carousel-03&orientation=landscape',
    stat: '6.3k 人参与',
  },
  {
    title: '街拍时刻',
    tag: '经典赛道',
    desc: '捕捉城市街头最真实的表情和姿态。黑白或彩色，人物或场景，用快门定格流动的城市故事。',
    image: 'https://readdy.ai/api/search-image?query=Street%20photography%20candid%20moment%20in%20city%2C%20natural%20light%2C%20urban%20architecture%20background%2C%20people%20walking%2C%20artistic%20black%20and%20white%20tones%2C%20editorial%20quality%2C%20clean%20composition%2C%20minimalist%20style&width=800&height=500&seq=carousel-04&orientation=landscape',
    stat: '9.8k 人参与',
  },
  {
    title: '文字创作擂台',
    tag: '特色赛道',
    desc: '短诗、微小说、散文随笔，用文字的力量打动人心。每天一个主题词，激发你的创作灵感。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20writing%20desk%20with%20notebook%20and%20pen%2C%20warm%20ambient%20light%20from%20window%2C%20coffee%20cup%2C%20minimal%20workspace%2C%20artistic%20lifestyle%20photography%2C%20soft%20natural%20tones%2C%20clean%20composition%2C%20editorial%20style&width=800&height=500&seq=carousel-05&orientation=landscape',
    stat: '4.5k 人参与',
  },
  {
    title: '宠物萌力全开',
    tag: '人气赛道',
    desc: '毛孩子的可爱瞬间就是最好的作品。抓拍你家主子最搞笑、最温馨的画面，萌翻全场。',
    image: 'https://readdy.ai/api/search-image?query=Cute%20cat%20and%20dog%20playing%20in%20sunlit%20room%2C%20warm%20natural%20light%2C%20cozy%20home%20interior%2C%20happy%20pet%20moment%2C%20soft%20bokeh%20background%2C%20lifestyle%20pet%20photography%2C%20clean%20aesthetic%2C%20editorial%20quality&width=800&height=500&seq=carousel-06&orientation=landscape',
    stat: '1.5w 人参与',
  },
];

export const featuresItems = [
  {
    icon: 'ri-lightbulb-flash-line',
    title: '每日新话题',
    desc: '每天零点准时更新当日话题，覆盖摄影、视频、文字、生活等多元赛道，让创作灵感源源不断，永远有新的挑战等着你。',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: '透明榜单',
    desc: '实时更新的排行榜机制，综合热度、互动和质量三个维度公平计算。每小时的榜单变化都公开可查，让好内容获得应有的曝光。',
  },
  {
    icon: 'ri-send-plane-line',
    title: '一键投稿爆料',
    desc: '通过大赛发布页面快速提交作品或发送爆料提名，支持多格式上传，审核流程简洁高效，让你的内容最快速度进入榜单候选池。',
  },
];

export const topicsItems = [
  { tag: '#摄影大赛', heat: '1.2w', color: 'primary' },
  { tag: '#街拍时刻', heat: '9.8k', color: 'accent' },
  { tag: '#美食日记', heat: '8.3k', color: 'secondary' },
  { tag: '#宠物星球', heat: '1.5w', color: 'primary' },
  { tag: '#创意视频', heat: '7.6k', color: 'accent' },
  { tag: '#旅行游记', heat: '6.2k', color: 'secondary' },
  { tag: '#生活美学', heat: '5.8k', color: 'primary' },
  { tag: '#文字创作', heat: '4.5k', color: 'accent' },
  { tag: '#时尚穿搭', heat: '8.9k', color: 'secondary' },
  { tag: '#建筑设计', heat: '3.7k', color: 'primary' },
  { tag: '#数码评测', heat: '4.1k', color: 'accent' },
];

export const mediaItems = [
  {
    title: '本周最佳：城市光影记录',
    author: '光影猎人',
    views: '12.8w',
    duration: '03:42',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20city%20timelapse%20at%20sunset%2C%20urban%20skyline%20with%20warm%20golden%20light%2C%20modern%20architecture%2C%20dramatic%20clouds%2C%20clean%20aesthetic%2C%20editorial%20videography%20style%2C%20professional%20color%20grading%2C%20minimalist%20composition&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    title: '创作者访谈：从素人到上榜',
    author: '大赛编辑部',
    views: '8.6w',
    duration: '05:18',
    image: 'https://readdy.ai/api/search-image?query=Professional%20interview%20setup%20in%20creative%20studio%2C%20warm%20lighting%2C%20modern%20interior%20with%20plants%2C%20two%20people%20talking%2C%20artistic%20atmosphere%2C%20clean%20composition%2C%20editorial%20quality%2C%20soft%20natural%20tones&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    title: '赛道解读：如何拍好美食',
    author: '美食达人赛赛',
    views: '6.3w',
    duration: '02:55',
    image: 'https://readdy.ai/api/search-image?query=Overhead%20cooking%20scene%20in%20bright%20kitchen%2C%20fresh%20ingredients%20arranged%20beautifully%2C%20hands%20preparing%20food%2C%20warm%20natural%20daylight%2C%20clean%20minimal%20aesthetic%2C%20editorial%20food%20photography%20style%2C%20soft%20shadows&width=640&height=360&seq=media-03&orientation=landscape',
  },
];

export const rankingItems = [
  { rank: 1, title: '雨后城市的倒影世界', author: '光影猎人', heat: '28.6k', tag: '摄影' },
  { rank: 2, title: '奶奶的拿手红烧肉', author: '厨房日记', heat: '24.3k', tag: '美食' },
  { rank: 3, title: '我家猫主子的日常', author: '猫奴小王', heat: '22.1k', tag: '宠物' },
  { rank: 4, title: '凌晨四点的菜市场', author: '人间观察者', heat: '19.8k', tag: '街拍' },
  { rank: 5, title: '写给夏天的十四行诗', author: '诗与远方', heat: '17.5k', tag: '文字' },
];

export const cardsItems = [
  {
    title: '夏日限定：海边故事征集',
    tag: '进行中',
    tagColor: 'primary',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20tropical%20beach%20at%20sunset%2C%20soft%20waves%2C%20warm%20golden%20light%2C%20palm%20trees%20silhouette%2C%20peaceful%20atmosphere%2C%20clean%20minimal%20aesthetic%2C%20travel%20photography%20style%2C%20dreamy%20composition&width=600&height=400&seq=cards-01&orientation=landscape',
    desc: '这个夏天你在海边发生了什么难忘的故事？用照片和文字记录下属于你的海边记忆，赢取夏日限定徽章。',
    stat: '1.2w 作品',
  },
  {
    title: '城市夜拍技巧分享',
    tag: '教程',
    tagColor: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=Night%20cityscape%20with%20colorful%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20modern%20urban%20scenery%2C%20long%20exposure%20photography%20style%2C%20vibrant%20colors%2C%20clean%20composition%2C%20editorial%20quality%2C%20minimalist%20aesthetic&width=600&height=400&seq=cards-02&orientation=landscape',
    desc: '夜景拍摄不再难！从参数设置到构图技巧，分享专业摄影师的夜拍心得，让你的城市夜景作品脱颖而出。',
    stat: '8.6k 阅读',
  },
  {
    title: '每周精选：人文纪实作品展',
    tag: '精选',
    tagColor: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20photography%20of%20elderly%20craftsman%20working%20in%20traditional%20workshop%2C%20warm%20natural%20light%2C%20rich%20textures%2C%20authentic%20moment%2C%20artistic%20composition%2C%20clean%20background%2C%20editorial%20quality%2C%20minimal%20aesthetic&width=600&height=400&seq=cards-03&orientation=landscape',
    desc: '本周精选十组人文纪实作品，从市井生活到传统文化，用镜头讲述平凡人不平凡的故事。',
    stat: '1.5w 阅读',
  },
  {
    title: '新手创作者入门指南',
    tag: '指南',
    tagColor: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=Person%20holding%20camera%20in%20bright%20modern%20studio%2C%20creative%20workspace%20with%20plants%2C%20warm%20natural%20light%2C%20minimal%20interior%2C%20beginner%20photography%20setup%2C%20clean%20aesthetic%2C%20editorial%20style%2C%20soft%20tones&width=600&height=400&seq=cards-04&orientation=landscape',
    desc: '第一次参与大赛不知道从哪里开始？这份入门指南帮你快速了解参赛流程、作品要求和提升上榜概率的实用技巧。',
    stat: '3.2k 阅读',
  },
  {
    title: '热门话题：极简主义生活',
    tag: '话题',
    tagColor: 'primary',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20living%20room%20with%20clean%20lines%2C%20neutral%20color%20palette%2C%20large%20window%20with%20natural%20light%2C%20scandinavian%20design%2C%20simple%20furniture%2C%20peaceful%20atmosphere%2C%20architectural%20photography%2C%20soft%20shadows&width=600&height=400&seq=cards-05&orientation=landscape',
    desc: '用镜头探索极简生活美学，记录你身边的简约之美。少即是多，简单生活也可以很精彩。',
    stat: '6.8k 作品',
  },
  {
    title: '创作者故事：从零到上榜',
    tag: '故事',
    tagColor: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Young%20creative%20person%20working%20on%20laptop%20in%20cozy%20cafe%2C%20warm%20ambient%20lighting%2C%20modern%20interior%20with%20greenery%2C%20focused%20expression%2C%20lifestyle%20photography%2C%20clean%20composition%2C%20editorial%20quality%2C%20soft%20tones&width=600&height=400&seq=cards-06&orientation=landscape',
    desc: '他是一位普通上班族，利用业余时间参赛，三个月内12次上榜。听听他的创作心得和时间管理方法。',
    stat: '4.1k 阅读',
  },
  {
    title: '秋季赛程预告',
    tag: '预告',
    tagColor: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=Autumn%20forest%20path%20with%20colorful%20falling%20leaves%2C%20warm%20golden%20sunlight%20through%20trees%2C%20peaceful%20nature%20scene%2C%20soft%20orange%20and%20yellow%20tones%2C%20clean%20composition%2C%20editorial%20quality%2C%20dreamy%20atmosphere&width=600&height=400&seq=cards-07&orientation=landscape',
    desc: '秋季赛季将于9月正式启动，新增"金秋影像"和"创意剪辑"两个全新赛道。提前了解赛制变化，做好参赛准备。',
    stat: '9.2k 关注',
  },
];

export const updatesItems = [
  {
    time: '2026-07-30 10:30',
    tag: '公告',
    title: '七月赛季收官倒计时，月度榜单明日揭晓',
  },
  {
    time: '2026-07-30 08:15',
    tag: '新赛道',
    title: '"城市夜行者"赛道正式上线，夜拍爱好者速来',
  },
  {
    time: '2026-07-29 18:42',
    tag: '热门',
    title: '今日"夏日记忆"赛道参赛作品突破1.5万件',
  },
  {
    time: '2026-07-29 14:20',
    tag: '活动',
    title: '本周六"创作训练营"线上直播，知名摄影师分享构图秘诀',
  },
  {
    time: '2026-07-29 09:00',
    tag: '公告',
    title: '平台功能更新：首页信息流算法优化，内容曝光更公平',
  },
  {
    time: '2026-07-28 16:55',
    tag: '榜单',
    title: '上周热门榜单回顾："街拍时刻"赛道诞生三匹黑马',
  },
  {
    time: '2026-07-28 11:30',
    tag: '活动',
    title: '与旅行博主联合发起"我的城市Vlog"联合创作活动',
  },
  {
    time: '2026-07-27 20:10',
    tag: '热门',
    title: '新人创作者"北城小雨"连续5天霸榜，引发社区热议',
  },
  {
    time: '2026-07-27 08:00',
    tag: '公告',
    title: '八月话题征集开始，欢迎创作者提交你期待的话题方向',
  },
];

export const commentsItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20cartoon%20portrait%20of%20a%20young%20person%20with%20warm%20smile%2C%20simple%20flat%20design%2C%20soft%20colors%2C%20clean%20background%2C%20illustration%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '摄影爱好者小李',
    time: '2 小时前',
    content: '参加了三周的每日大赛，真的上瘾了！每天都有新话题让人有动力去创作，而且上榜的满足感太强了。从刚开始的无人问津到现在有固定粉丝，平台给了我很大的成长空间。',
    likes: 328,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cartoon%20portrait%20of%20a%20young%20woman%2C%20simple%20flat%20design%2C%20warm%20tones%2C%20clean%20background%2C%20illustration%20style%2C%20friendly%20expression&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '美食博主菜菜',
    time: '5 小时前',
    content: '通过mrds发送爆料功能推荐了几个朋友的作品，都成功上榜了！而且爆料通道真的很方便，审核也快。希望平台越做越大，让更多好创作者被看见。',
    likes: 256,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20cartoon%20portrait%20of%20a%20young%20man%20with%20glasses%2C%20minimalist%20flat%20design%2C%20cool%20tones%2C%20clean%20background%2C%20illustration%20style%2C%20friendly%20expression&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '街拍达人阿杰',
    time: '8 小时前',
    content: '街拍赛道的老粉了，每次新话题出来都第一时间蹲点。最近发现平台对作品质量的把控越来越好了，劣质内容确实少了，值得点赞。希望文字创作区也能多一些互动功能。',
    likes: 189,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20cartoon%20portrait%20of%20a%20young%20girl%2C%20simple%20flat%20design%2C%20pink%20tones%2C%20clean%20background%2C%20illustration%20style%2C%20happy%20expression&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '萌宠守护者花花',
    time: '12 小时前',
    content: '宠物赛道简直就是为我家毛孩子量身定做的！每天拍几张照片参赛已经成为习惯了，虽然还没上过榜，但认识了好多同样爱宠物的朋友，这个社区的友好氛围真的很好。',
    likes: 142,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cartoon%20portrait%20of%20a%20young%20person%20with%20beanie%2C%20simple%20flat%20design%2C%20warm%20earth%20tones%2C%20clean%20background%2C%20illustration%20style%2C%20cool%20expression&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '自由创作者Nico',
    time: '1 天前',
    content: '作为一名业余创作者，每日大赛mrds给了我一个持续创作的理由。榜单机制很透明，不会因为你是新手就被埋没。建议增加更多跨赛道联动的玩法，比如摄影+文字的混合作品。',
    likes: 97,
  },
];

export const indexItems = [
  { title: '摄影大赛', count: '48 个话题', icon: 'ri-camera-line' },
  { title: '短视频创作', count: '35 个话题', icon: 'ri-video-line' },
  { title: '文字创作', count: '29 个话题', icon: 'ri-quill-pen-line' },
  { title: '美食日记', count: '22 个话题', icon: 'ri-restaurant-line' },
  { title: '街拍纪实', count: '31 个话题', icon: 'ri-walk-line' },
  { title: '宠物星球', count: '26 个话题', icon: 'ri-heart-pulse-line' },
  { title: '旅行游记', count: '19 个话题', icon: 'ri-earth-line' },
  { title: '创意设计', count: '15 个话题', icon: 'ri-paint-brush-line' },
];

export const aboutData = {
  title: '关于每日大赛mrds',
  content:
    '每日大赛mrds是一个专注于全民创作竞技的社区平台。我们相信，每个人都有独特的视角和表达方式，值得被更多人看见。通过每日更新的创作话题、透明的榜单机制和便捷的投稿爆料通道，我们致力于为每一位创作者提供公平、有趣、有温度的展示舞台。无论你是专业摄影师、短视频达人、文字创作者，还是刚刚拿起手机记录生活的普通人，这里都有属于你的赛道。每天都是新的开始，每个作品都值得掌声。',
  stats: [
    { label: '入驻创作者', value: '50,000+' },
    { label: '日均参赛作品', value: '8,500+' },
    { label: '累计话题数', value: '240+' },
    { label: '社区互动量', value: '1,200万+' },
  ],
};